(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instructors"] && !Shopify.designMode) return;
  try {
    
  class InstructorsShowcase {
    constructor(container) {
      this.container = container;
      this.filterButtons = Array.from(this.container.querySelectorAll('.instructors-showcase__filter-btn'));
      this.instructorCards = Array.from(this.container.querySelectorAll('.instructor-card'));

      this.handleFilterClick = this.handleFilterClick.bind(this);
      this.handleContainerClick = this.handleContainerClick.bind(this);

      if (this.filterButtons.length) {
        this.filterButtons.forEach(button => {
          button.addEventListener('click', this.handleFilterClick);
        });
      }

      this.container.addEventListener('click', this.handleContainerClick);
    }

    handleFilterClick(event) {
      event.preventDefault();
      const clickedButton = event.currentTarget;
      const filterValue = clickedButton.dataset.filter;

      this.filterButtons.forEach(btn => btn.classList.remove('active'));
      clickedButton.classList.add('active');

      if (!this.instructorCards.length) return;

      this.instructorCards.forEach(card => {
        const cardCategories = card.dataset.category || '';
        const isVisible = filterValue === 'all' || cardCategories.includes(filterValue);
        card.classList.toggle('instructor-card--hidden', !isVisible);
      });
    }

    handleContainerClick(event) {
      const toggle = event.target.closest('.instructor-card__collapsible-toggle');
      if (!toggle || !this.container.contains(toggle)) return;

      event.preventDefault();
      this.toggleCollapsible(toggle);
    }

    toggleCollapsible(button) {
      const targetId = button.getAttribute('aria-controls');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const newState = !isExpanded;

      button.setAttribute('aria-expanded', String(newState));
      if (newState) {
        target.removeAttribute('hidden');
      } else {
        target.setAttribute('hidden', '');
      }

      const label = button.querySelector('.toggle-label');
      const collapseLabel = button.dataset.collapsedLabel;
      const expandLabel = button.dataset.expandedLabel;

      if (label && collapseLabel && expandLabel) {
        label.textContent = newState ? expandLabel : collapseLabel;
      }
    }

    destroy() {
      if (this.filterButtons.length) {
        this.filterButtons.forEach(button => {
          button.removeEventListener('click', this.handleFilterClick);
        });
      }
      this.container.removeEventListener('click', this.handleContainerClick);
    }
  }

  const initInstructorsShowcaseSections = (root = document) => {
    const sections = root.querySelectorAll('[data-section-type="instructors-showcase"]');
    sections.forEach(section => {
      if (section.instructorsShowcaseInstance) {
        section.instructorsShowcaseInstance.destroy();
      }
      section.instructorsShowcaseInstance = new InstructorsShowcase(section);
    });
  };

  const destroyInstructorsShowcaseSections = (root = document) => {
    const sections = root.querySelectorAll('[data-section-type="instructors-showcase"]');
    sections.forEach(section => {
      if (section.instructorsShowcaseInstance) {
        section.instructorsShowcaseInstance.destroy();
        delete section.instructorsShowcaseInstance;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initInstructorsShowcaseSections());
  } else {
    initInstructorsShowcaseSections();
  }

  document.addEventListener('shopify:section:load', event => {
    initInstructorsShowcaseSections(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    destroyInstructorsShowcaseSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-grid"] && !Shopify.designMode) return;
  try {
    
  class PriceGridMeta {
    constructor(container) {
      this.container = container;
      this.tabButtons = this.container.querySelectorAll('.pricing-card-tabs__button');
      this.cards = this.container.querySelectorAll('.price-card');

      if (!this.tabButtons.length) return;

      this.tabButtons.forEach(button => {
        button.addEventListener('click', this.handleTabClick.bind(this));
      });
    }

    handleTabClick(event) {
      event.preventDefault();
      const clickedButton = event.currentTarget;
      const tabValue = clickedButton.dataset.tab;

      // Update active state
      this.tabButtons.forEach(btn => btn.classList.remove('active'));
      clickedButton.classList.add('active');

      // Filter cards
      this.cards.forEach(card => {
        const cardCategory = card.dataset.category;
        const isVisible = (tabValue === 'all' || cardCategory === tabValue);

        if (isVisible) {
          card.classList.remove('price-card--hidden');
          // Simple fade in animation reset
          card.style.opacity = '0';
          setTimeout(() => card.style.opacity = '1', 50);
        } else {
          card.classList.add('price-card--hidden');
        }
      });
    }
  }

  const initPriceGridMeta = () => {
    document.querySelectorAll('[data-section-type="pricing-card-grid"]').forEach(section => {
      if (!section.priceGridInstance) {
        section.priceGridInstance = new PriceGridMeta(section);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceGridMeta);
  } else {
    initPriceGridMeta();
  }

  document.addEventListener('shopify:section:load', event => {
    if (event.target.dataset.sectionType === 'pricing-card-grid') {
      event.target.priceGridInstance = new PriceGridMeta(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
